module.exports = __webpack_public_path__ + "static/media/intropart1.f39a6141.png";